import { createFeatureSelector, createSelector } from '@ngrx/store';
import { articlesKey, ArticleState } from '../reducer/reducer'

export const selectArticleState = createFeatureSelector<ArticleState>(articlesKey);

export const getBlogs = createSelector(selectArticleState, state => state.articles);